// Imports
import { faAt, faDesktop, faPhone } from '@fortawesome/pro-regular-svg-icons';
import styled from 'styled-components/macro';
import { useAppSelector } from '../../../../../../shareables/foundation/front-end/redux/hooks';
import { GetContactItemsResponse } from '../../../../../../shareables/types/api/main/website/page/type/217/contact-items/get';
import formatPhoneNumber from '../../../../../../shareables/utils/format-phone-number';
import ContactInfo, { ContactDetails } from '../shared-components/contact-info';


// Styled components
const HeaderCell = styled.td`
	max-width: 0;
	
	&& {
		white-space: normal;
	}
`;

const ContactInfoCell = styled.td`
	max-width: 0;
`;


// Define the accepted props
interface Props {
	contactInfo: GetContactItemsResponse[0];
}


// Function component
const UsefulContactInformationRow: React.FC<Props> = ({ contactInfo }) => {
	// Use Redux functionality
	const website = useAppSelector((state) => state.self.website);
	
	
	// Return JSX
	return (
		<tr>
			<HeaderCell colSpan={contactInfo.type === 'HEADER' ? 2 : undefined}>
				{contactInfo.type === 'HEADER' ? <strong>{contactInfo.title}</strong> : contactInfo.title}
			</HeaderCell>
			
			{contactInfo.type === 'CONTACT' && (
				<ContactInfoCell>
					<ContactInfo
						contactDetails={[
							contactInfo.url
								? {
										icon: faDesktop,
										href: contactInfo.url,
										text: contactInfo.url,
									}
								: null,
							contactInfo.phone
								? {
										icon: faPhone,
										href: `tel:${contactInfo.phone}`,
										text: formatPhoneNumber(contactInfo.phone, website?.country.callingCode ?? 1),
									}
								: null,
							contactInfo.email
								? {
										icon: faAt,
										href: `mailto:${contactInfo.email}`,
										text: contactInfo.email,
									}
								: null,
						].filter((contact): contact is ContactDetails => contact !== null)}
					/>
				</ContactInfoCell>
			)}
		</tr>
	);
};

export default UsefulContactInformationRow;
